/* eslint-disable import/extensions */
export { default as UpdateIssueButton } from './UpdateIssueButton.vue';
export { default as IssueStatusButton } from './IssueStatusButton.vue';
